import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FreeUnderLine from '../../../../assets/images/invitations/free-underline-teal.svg';
import FreeUnderLinePink from '../../../../assets/images/invitations/free-underline-pink.svg';
import styles from './styles.module.less';

function Free({ freeStyle, isPink, isLowercase = false }) {
  return (
    <div className={styles.free}>
      <span style={freeStyle}>{isLowercase ? 'free' : 'FREE'}</span>
      <img
        src={isPink ? FreeUnderLinePink : FreeUnderLine}
        alt="free"
        className={cx('zolaicon', styles.freeImg)}
      />
    </div>
  );
}

Free.propTypes = {
  freeStyle: PropTypes.shape({}),
  isPink: PropTypes.bool,
  isLowercase: PropTypes.bool,
};

export default Free;



// WEBPACK FOOTER //
// ./src/cards/components/CardDetail/Free/Free.jsx